import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectLoading } from '@store/system/system.selector';

@Injectable({ providedIn: 'root' })
export class CoreService {
    public loading$ = this.store.select(selectLoading);
    constructor(private store: Store) {}
}
